import { connect } from 'react-redux';
import {
  handleContactFetch,
  handleProcessContactItem,
  handleProcessItemWithFiles,
  handleFilterItems,
  handleFetchRiaContactRelationships,
  handleDeleteRiaContactPhoto,
  handleResetUpdatingItemWithFiles,
} from '../../actions/admin_actions';
import EditContactModalRebuild from "../../components/admin/riaContacts/EditContactModalRebuild";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
    adminFetchContact: state.adminFetchContact.adminFetchContact,
    adminUpdateItemWithFiles: state.adminUpdateItemWithFiles.adminUpdateItemWithFiles,
    adminUpdateContact: state.adminUpdateContact.adminUpdateContact,
    adminFilterItems: state.adminFilterItems.adminFilterItems,
    adminContactRelationships: state.adminContactRelationships.adminContactRelationships,
    deletedRiaContactPhoto: state.deletedRiaContactPhoto.deletedRiaContactPhoto,
  }
}

const AdminEditContactContainer = connect(mapStateToProps, {
  handleContactFetch,
  handleProcessContactItem,
  handleProcessItemWithFiles,
  handleFilterItems,
  handleFetchRiaContactRelationships,
  handleDeleteRiaContactPhoto,
  handleResetUpdatingItemWithFiles,
})(EditContactModalRebuild)

export default AdminEditContactContainer;